import apiClient from '@/services/AccountClient'
import { CARD_TYPES } from '@/models/CardOrder'
import { CARD_FEE_TYPES } from '@/models/Card'
import { HEADER_SKIP_AUTOEXTEND } from '@/services/ApiClient/ApiClient'

export default {
  fetchAllCardOrders (params = {}) {
    const defaultSort = 'updatedAt,desc'

    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/issuing/orders',
      {
        ...params,
        sort: [].concat(params.sort, defaultSort)
      }
    )
  },
  fetchCardOrderTotalCount (options) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/issuing/orders/count',
      null,
      {
        headers: { [HEADER_SKIP_AUTOEXTEND]: true },
        ...options
      }
    )
  },
  fetchCardOrderById (id) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/issuing/orders/${id}`
    )
  },
  fetchCardOrderSecureInfo (id) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/issuing/orders/${id}/secure-info`
    )
  },
  fetchCardCurrencyList () {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/issuing/currency-list'
    )
  },
  fetchCardLimits (id) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/issuing/cards/${id}/limits`
    )
  },
  createCardOrder (profileId, data) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/issuing/orders?profileId=${profileId}`,
      data
    )
  },
  updateCardOrder (id, data) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/issuing/orders/${id}`,
      data
    )
  },
  updateRenewalCardOrder (id, data) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/issuing/renewal-orders/${id}`,
      data
    )
  },
  updateCardPhoneNumber (id, phoneNumber) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/issuing/cards/${id}/phone-number`,
      { phoneNumber }
    )
  },
  updateCardLimits (id, data) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/issuing/cards/${id}/limits`,
      data
    )
  },
  acceptCardOrder (id) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/issuing/orders/${id}/accept`
    )
  },
  registerCardOrder (id) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/issuing/orders/${id}/register`
    )
  },
  syncCardOrder (id) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/issuing/orders/${id}/sync`
    )
  },
  declineCardOrder (id, reason) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/issuing/orders/${id}/decline`,
      { reason }
    )
  },
  activateCard (id, activationCode) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/issuing/cards/${id}/activate`,
      { activationCode }
    )
  },
  freezeCard (id, { type, reason }) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/issuing/cards/${id}/freeze`,
      { type, reason }
    )
  },
  unfreezeCard (id, reason) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/issuing/cards/${id}/unfreeze`,
      { reason }
    )
  },
  calculateCardIssuingFee (profileId, feeCurrency, cardCurrency, cardType, details = {}) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/issuing/profiles/${profileId}/calculate-fee`,
      {
        type: CARD_FEE_TYPES.ISSUING,
        cardCurrency,
        feeCurrency,
        cardType,
        details
      }
    )
  },
  calculateCardDeliveryFee (profileId, feeCurrency, details = {}) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/issuing/profiles/${profileId}/calculate-fee`,
      {
        type: CARD_FEE_TYPES.DELIVERY,
        cardType: CARD_TYPES.REAL,
        cardCurrency: 'EUR',
        feeCurrency,
        details
      }
    )
  }
}
